import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FilterService {
  preserveDataOnNextNavigation: boolean = false;
  private filters: Record<string, Record<string, any>> = {};
  private filterSubjects: Record<string, BehaviorSubject<Record<string, any>>> = {};

  // Set filters for a specific context (e.g., 'user', 'booking')
  setFilters(context: string, filters: Record<string, any>): void {
    this.filters[context] = filters;

    if (!this.filterSubjects[context]) {
      this.filterSubjects[context] = new BehaviorSubject<Record<string, any>>(filters);
    } else {
      this.filterSubjects[context].next(filters);
    }
  }

  // Get filters for a specific context
  getFilters(context: string): Record<string, any> {
    return this.filters[context] || {};
  }

  // Clear filters for a specific context
  clearFilters(context: string): void {
    if (!this.preserveDataOnNextNavigation) {
      delete this.filters[context];
      if (this.filterSubjects[context]) {
        this.filterSubjects[context].next({});
      }
    }
    this.preserveDataOnNextNavigation = false;
  }

  // Subscribe to filter changes for a specific context
  filters$(context: string): Observable<Record<string, any>> {
    if (!this.filterSubjects[context]) {
      this.filterSubjects[context] = new BehaviorSubject<Record<string, any>>({});
    }
    return this.filterSubjects[context].asObservable();
  }
}
